var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChaticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2934 9.35152C18.2967 10.5981 18.0054 11.8277 17.4434 12.9404C16.7771 14.2737 15.7526 15.3952 14.4849 16.1792C13.2172 16.9632 11.7562 17.3787 10.2657 17.3793C9.01912 17.3825 7.78944 17.0913 6.67678 16.5293L1.29346 18.3237L3.0879 12.9404C2.52589 11.8277 2.23465 10.5981 2.2379 9.35152C2.23848 7.86096 2.65403 6.4 3.43802 5.13227C4.22201 3.86454 5.34347 2.84012 6.67678 2.17376C7.78944 1.61175 9.01912 1.32051 10.2657 1.32376H10.7379C12.7064 1.43236 14.5658 2.26325 15.9598 3.65734C17.3539 5.05143 18.1848 6.91075 18.2934 8.8793V9.35152Z",
    stroke: "#623CE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChaticon);
export default __webpack_public_path__ + "static/media/chaticon.20b1042431fb9cf788768f6ad8394c3b.svg";
export { ForwardRef as ReactComponent };